import superagent from 'superagent'

import { TIMEOUTS } from '../../config/api-services'

const { RESPONSE_TIMEOUT, DEADLINE_TIMEOUT } = TIMEOUTS

const fetchApi = (url, query, headers = {}, responseTimeout = RESPONSE_TIMEOUT, deadlineTimeout = DEADLINE_TIMEOUT) =>
  new Promise((resolve, reject) =>
    superagent
      .get(url)
      .query(query)
      .timeout({
        response: responseTimeout,
        deadline: deadlineTimeout
      })
      .accept('json')
      .set(headers)
      .end((error, response) => (error || !response.body ? reject(error) : resolve(response.body)))
  )

const postApi = (
  url,
  body,
  query,
  headers = {},
  responseTimeout = RESPONSE_TIMEOUT,
  deadlineTimeout = DEADLINE_TIMEOUT
) =>
  new Promise((resolve, reject) =>
    superagent
      .post(url)
      .send(body)
      .query(query)
      .timeout({
        response: responseTimeout,
        deadline: deadlineTimeout
      })
      .set(headers)
      .retry(2)
      .end((error, response) => (error || !response.body ? reject(error) : resolve(response.body)))
  )

export { fetchApi, postApi }
